'use client'

import { ModelLogos, ScrollToTopButton } from '@/components/marketing'
import { HeroSection } from './HeroSection'
import { ProblemSection } from './ProblemSection'
import { ShowcaseSection } from './ShowcaseSection'

export function HomePageContent() {
  return (
    <div className="flex min-h-screen scroll-smooth flex-col bg-black text-white">
      <HeroSection />
      <ProblemSection />
      <ShowcaseSection />
      <ModelLogos />
      <ScrollToTopButton />
    </div>
  )
}
